import { useEffect } from 'react';
import { usePreferences } from '@/core/contexts/PreferencesContext';
import { useTheme } from '@/hooks/useTheme';

/**
 * Componente que sincroniza el tema del usuario desde PreferencesContext
 * El tema ya viene de /session/init, no necesita hacer request adicional
 */
export function ThemeSync() {
  const { theme } = usePreferences();
  const { syncFromBackend } = useTheme();

  useEffect(() => {
    if (theme) {
      // Sincronizar el tema desde PreferencesContext
      // 'auto' se mapea a 'system' en useTheme
      syncFromBackend(theme);
    }
  }, [theme, syncFromBackend]);

  return null; // Este componente no renderiza nada
}
